import { render, staticRenderFns } from "./AuditLogIndex.vue?vue&type=template&id=a80e41d4&"
import script from "./AuditLogIndex.vue?vue&type=script&lang=js&"
export * from "./AuditLogIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports